import '@style/common/main-style'

import '@style/common/button.css'
import '@style/common/breadcrumbs.css'

import '@core/components/template/skeleton/card'
import '@core/components/template/pagination'

import '@style/components/template/pagination/page.css'
import '@style/components/template/Card/index.css'

import './index.css'

import { deletePage } from '@utils/browserTest.ts'
import { removeCurrentPageClickEvent } from '@core/components/template/breadcrumbs'
import { generateComponentsElements } from '@core/views/components/generate.ts'
import { useChaptersCourses } from '@core/composables/useChaptersCourses.ts'

document.addEventListener('DOMContentLoaded', () => {
  deletePage().then(() => {
    if (import.meta.env.DEV) {
      generateComponentsElements(document)
    }

    removeCurrentPageClickEvent()

    useChaptersCourses.loadElements('tutorials', { pageNumber: '1', isComponents: true })
  })
})
